import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionContainerComponent } from './accordion-container.component';
import { AccordionContentComponent } from './accordion-content.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [AccordionContainerComponent, AccordionContentComponent],
    exports: [AccordionContainerComponent, AccordionContentComponent]
})
export class AccordionContainerSharedModule {
}
